module.exports = __webpack_public_path__ + "15223dc94787e4ad0193eaffcf3097a6.otf";